import api from '../../../services/apiConfig';

export interface ExternalOrderListItem {
  id: number;
  id_externo: number;
  ultima_alteracao: string | null;
  status: string;
  total: number;
  operacoes_fiscais?: number;
  condicao_pagamento: string;
  data_emissao: string;
  cliente_razao_social: string | null;
  cliente_cnpj: string;
  cliente_cidade: string | null;
  cliente_estado: string;
  cliente_telefone: string | null;
  pedido_situacao: number | null;
  VENDEDOR_NOME?: string | null;
  operacao_fiscal_desc?: string | null;
  situacao_desc?: string | null;
  status_avaliacao?: string | null;
  total_aprovados?: number;
  total_reprovados?: number;
  etapas_status?: string | null;
}

export interface ExternalOrdersResponse {
  items: ExternalOrderListItem[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
  };
}

export interface SampleOrderDetails {
  id: number;
  pedido_id: number;
  cliente_id: number;
  possui_filial: string | null;
  unidade_compra: string | null;
  num_usuarios: number | null;
  contato_principal: string | null;
  telefone_contato: string | null;
  email_contato: string | null;
  ca_marca_atual: string | null;
  riscos_area: string | null;
  insatisfacao_atual: string | null;
  calcado_sugerido: string | null;
  observacoes: string | null;
}

export interface ClientJoinedInfo {
  ID: number;
  NOME: string | null;
  FANTASIA: string | null;
  DOCUMENTO: string | null;
  EMAIL: string | null;
  TELEFONE: string | null;
  CIDADE: string | null;
  ESTADO: string | null;
  BASE: number | null;
  BASE_NOME?: string | null;
  VENDEDOR_NOME?: string | null;
  BASE_PRODUCAO_NOME?: string | null;
  SEGMENTO_CLASSE?: string | null;
}

export interface BaseJoinedInfo {
  ID: number;
  BASE: string | null;
  REGIONAL: string | null;
  SUPERVISOR: string | null;
  REGIONAL_NOME: string | null;
  DESC_PEDIDO: string | null;
  TELEFONE: string | null;
}

export interface ExternalOrderItemGrade {
  id: number;
  id_pedido_externo_item: number;
  tamanho: string;
  quantidade: number;
}

export interface ExternalOrderItem {
  id: number;
  id_externo: number;
  quantidade: number;
  preco_item: number;
  subtotal: number | null;
  referencia: string;
  descricao: string | null;
  tabela_preco: string;
  opcional: string | null;
  grades: ExternalOrderItemGrade[];
}

export interface ExternalOrderDetails {
  pedido_externo: ExternalOrderListItem;
  amostra_pedido: SampleOrderDetails | null;
  cliente: ClientJoinedInfo | null;
  base: BaseJoinedInfo | null;
  itens_pedido: ExternalOrderItem[];
}

export const fetchExternalOrders = async (
  page = 1,
  limit = 20,
  filters: {
    search?: string;
    dataI?: string;
    dataF?: string;
    status?: string;
    operacao?: string;
  } = {}
) => {
  return api.get<ExternalOrdersResponse>('/orders/sample-external', {
    params: { page, limit, ...filters },
  });
};

export const fetchExternalOrderDetails = async (orderId: number) => {
  return api.get<ExternalOrderDetails>(`/orders/sample-external/${orderId}`);
};

export const updateSampleOrderStatus = (orderId: number, status: 0 | 2) => {
  return api.put(`/orders/sample-external/${orderId}/status`, { status });
};
